// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-detail-page {
  background: #f4f6f8;
}

.listing-back-btn {
  color: #475569;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.listing-back-btn mat-icon {
  margin-right: 4px;
  vertical-align: middle;
}

.listing-hero-card {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 14px;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.listing-hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.listing-title {
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
  font-weight: 700;
  line-height: 1.25;
  color: #0f172a;
  margin: 0 0 0.35rem;
  letter-spacing: -0.02em;
}

.fulfillment-badge-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.35rem;
}

.fulfillment-badge {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #1e3a5f;
  background: #e8f1fb;
  border: 1px solid #c5daf5;
}

.fulfillment-ships {
  font-size: 0.85rem;
  color: #64748b;
}

.listing-price-block {
  flex-shrink: 0;
  text-align: right;
}

.listing-price-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  margin-bottom: 0.15rem;
}

.listing-price {
  font-size: clamp(1.35rem, 2.5vw, 1.85rem);
  font-weight: 700;
  color: #0d9488;
  line-height: 1.1;
}

.listing-meta-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  border-top: 1px solid #eef2f6;
  padding-top: 1rem;
}

.listing-meta-item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  font-size: 0.95rem;
  color: #334155;
}
.listing-meta-item mat-icon {
  font-size: 1.15rem;
  width: 1.15rem;
  height: 1.15rem;
  color: #64748b;
  flex-shrink: 0;
}
.listing-meta-item a {
  color: #0d9488;
  font-weight: 600;
  text-decoration: none;
}
.listing-meta-item a:hover {
  text-decoration: underline;
}
.listing-meta-item.listing-seller .seller-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  color: inherit;
  font-weight: 400;
  text-decoration: none;
}
.listing-meta-item.listing-seller .seller-chip strong {
  color: #0d9488;
  font-weight: 600;
}
.listing-meta-item.listing-seller .seller-chip:hover strong {
  text-decoration: underline;
}
.listing-meta-item.listing-seller .seller-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  background: #f1f5f9;
  flex-shrink: 0;
}

.listing-section {
  margin-top: 1.5rem;
}

.section-heading {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.85rem;
  letter-spacing: -0.01em;
}

.listing-specs-card {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 14px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.spec-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}
@media (min-width: 768px) {
  .spec-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.spec-tile {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.75rem 0.85rem;
  background: #f8fafc;
  border: 1px solid #eef2f6;
  border-radius: 10px;
  min-height: 100%;
}
.spec-tile img {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-top: 2px;
  opacity: 0.85;
}

.spec-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 0.15rem;
}

.spec-value {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
}

.listing-actions {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid #e8ecf0;
}

.listing-actions .black-button {
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0.65rem 1.25rem;
}

.listing-engagement {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.35rem 0.5rem;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #eef2f6;
}
@media (min-width: 768px) {
  .listing-engagement {
    justify-content: flex-end;
  }
}
.listing-engagement .engagement-stat {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  font-size: 0.875rem;
  color: #64748b;
  min-width: 2.5rem;
}

.listing-content-section {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 14px;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.description-body {
  font-size: 1rem;
  line-height: 1.75;
  color: #334155;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

.vehicle-card {
  display: none;
}

.flex-container {
  display: block;
}

.image-gallery {
  margin-top: 0;
}
.image-gallery .main-image {
  cursor: pointer;
  margin-bottom: 0;
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e8ecf0;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}
.image-gallery .main-image .main-img {
  width: 100%;
  height: 380px;
  object-fit: cover;
  border-radius: 0;
  transition: transform 0.25s ease;
}
.image-gallery .main-image .main-img:hover {
  transform: scale(1.015);
}

.image-360 {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}
.image-360:active {
  cursor: grabbing;
}

.image-360-indicator,
.image-360-controls {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 0.8rem;
  z-index: 10;
}

.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}
.lightbox-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.lightbox-content .close-btn,
.lightbox-content .nav-btn {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  font-size: 2rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}
.lightbox-content .close-btn:hover,
.lightbox-content .nav-btn:hover {
  background: rgb(255, 255, 255);
}
.lightbox-content .close-btn {
  top: -60px;
  right: 0;
}
.lightbox-content .prev {
  left: -60px;
  top: 50%;
  transform: translateY(-50%);
}
.lightbox-content .next {
  right: -60px;
  top: 50%;
  transform: translateY(-50%);
}
.lightbox-content .image-counter {
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  background: rgba(0, 0, 0, 0.7);
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .listing-hero-top {
    flex-direction: column;
  }
  .listing-price-block {
    text-align: left;
  }
  .spec-grid {
    grid-template-columns: 1fr;
  }
  .lightbox-content .close-btn {
    top: 10px;
    right: 10px;
    font-size: 1.5rem;
    width: 40px;
    height: 40px;
  }
  .lightbox-content .prev,
  .lightbox-content .next {
    font-size: 1.5rem;
    width: 40px;
    height: 40px;
  }
  .lightbox-content .prev {
    left: 10px;
  }
  .lightbox-content .next {
    right: 10px;
  }
  .lightbox-content .image-counter {
    bottom: 10px;
  }
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.message-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
}

.report-error {
  color: #842029;
  margin-top: 8px;
}

.report-success {
  color: #0f5132;
  margin-top: 8px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/category/listing-detail/listing-detail.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;AAAF;AAEE;EACE,iBAAA;EACA,sBAAA;AAAJ;;AAKA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AAFF;;AAKA;EACE,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;AAFF;;AAKA;EACE,yCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAFF;AAIE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAHJ;AAKI;EACE,0BAAA;AAHN;AAQI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AANN;AAQM;EACE,cAAA;EACA,gBAAA;AANR;AASM;EACE,0BAAA;AAPR;AAWI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AATN;;AAeA;EACE,kBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AAZF;;AAeA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;AAZF;AAcE;EALF;IAMI,qCAAA;EAXF;AACF;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAXF;AAaE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAXJ;;AAeA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;AAZF;;AAeA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAZF;;AAgBA;EACE,kBAAA;EACA,oBAAA;EACA,6BAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAbF;AAeE;EAVF;IAWI,yBAAA;EAZF;AACF;AAcE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAZJ;;AAiBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AAdF;;AAiBA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;AAdF;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAmBA;EACE,aAAA;AAhBF;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,4CAAA;AAhBJ;AAkBI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AAhBN;AAkBM;EACE,uBAAA;AAhBR;;AAsBA;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;AAnBF;AAqBE;EACE,gBAAA;AAnBJ;;AAuBA;;EAEE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AApBF;;AAwBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AArBF;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AArBJ;AAwBE;;EAEE,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAtBJ;AAwBI;;EACE,8BAAA;AArBN;AAyBE;EACE,UAAA;EACA,QAAA;AAvBJ;AA0BE;EACE,WAAA;EACA,QAAA;EACA,2BAAA;AAxBJ;AA2BE;EACE,YAAA;EACA,QAAA;EACA,2BAAA;AAzBJ;AA4BE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AA1BJ;;AA8BA;EACE;IACE,sBAAA;EA3BF;EA8BA;IACE,gBAAA;EA5BF;EA+BA;IACE,0BAAA;EA7BF;EAiCE;IACE,SAAA;IACA,WAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;EA/BJ;EAkCE;;IAEE,iBAAA;IACA,WAAA;IACA,YAAA;EAhCJ;EAmCE;IACE,UAAA;EAjCJ;EAoCE;IACE,WAAA;EAlCJ;EAqCE;IACE,YAAA;EAnCJ;AACF;AAwCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAtCF;;AAyCA;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,6CAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;AAtCF;;AAyCA;EACE,aAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAtCF;;AAyCA;EACE,cAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,cAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAtCF","sourcesContent":["// ── Page shell ──────────────────────────────────────────────────────────────\n.listing-detail-page {\n  background: #f4f6f8;\n}\n\n.listing-back-btn {\n  color: #475569;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n\n  mat-icon {\n    margin-right: 4px;\n    vertical-align: middle;\n  }\n}\n\n// ── Hero card (title, price, meta) ──────────────────────────────────────────\n.listing-hero-card {\n  background: #fff;\n  border: 1px solid #e8ecf0;\n  border-radius: 14px;\n  padding: 1.5rem 1.75rem;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.listing-hero-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.listing-title {\n  font-size: clamp(1.35rem, 2.5vw, 1.75rem);\n  font-weight: 700;\n  line-height: 1.25;\n  color: #0f172a;\n  margin: 0 0 0.35rem;\n  letter-spacing: -0.02em;\n}\n\n.fulfillment-badge-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.35rem;\n}\n\n.fulfillment-badge {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #1e3a5f;\n  background: #e8f1fb;\n  border: 1px solid #c5daf5;\n}\n\n.fulfillment-ships {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.listing-price-block {\n  flex-shrink: 0;\n  text-align: right;\n}\n\n.listing-price-label {\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n  margin-bottom: 0.15rem;\n}\n\n.listing-price {\n  font-size: clamp(1.35rem, 2.5vw, 1.85rem);\n  font-weight: 700;\n  color: #0d9488;\n  line-height: 1.1;\n}\n\n.listing-meta-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  border-top: 1px solid #eef2f6;\n  padding-top: 1rem;\n}\n\n.listing-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  font-size: 0.95rem;\n  color: #334155;\n\n  mat-icon {\n    font-size: 1.15rem;\n    width: 1.15rem;\n    height: 1.15rem;\n    color: #64748b;\n    flex-shrink: 0;\n  }\n\n  a {\n    color: #0d9488;\n    font-weight: 600;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &.listing-seller {\n    .seller-chip {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.55rem;\n      color: inherit;\n      font-weight: 400;\n      text-decoration: none;\n\n      strong {\n        color: #0d9488;\n        font-weight: 600;\n      }\n\n      &:hover strong {\n        text-decoration: underline;\n      }\n    }\n\n    .seller-avatar {\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n      object-fit: cover;\n      background: #f1f5f9;\n      flex-shrink: 0;\n    }\n  }\n}\n\n// ── Specifications ──────────────────────────────────────────────────────────\n.listing-section {\n  margin-top: 1.5rem;\n}\n\n.section-heading {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.85rem;\n  letter-spacing: -0.01em;\n}\n\n.listing-specs-card {\n  background: #fff;\n  border: 1px solid #e8ecf0;\n  border-radius: 14px;\n  padding: 1.25rem 1.5rem;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\n.spec-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.spec-tile {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.75rem 0.85rem;\n  background: #f8fafc;\n  border: 1px solid #eef2f6;\n  border-radius: 10px;\n  min-height: 100%;\n\n  img {\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n    margin-top: 2px;\n    opacity: 0.85;\n  }\n}\n\n.spec-label {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  margin-bottom: 0.15rem;\n}\n\n.spec-value {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.35;\n}\n\n// ── Actions ───────────────────────────────────────────────────────────────────\n.listing-actions {\n  margin-top: 1.5rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid #e8ecf0;\n}\n\n.listing-actions .black-button {\n  border-radius: 10px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  padding: 0.65rem 1.25rem;\n}\n\n.listing-engagement {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 0.35rem 0.5rem;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px solid #eef2f6;\n\n  @media (min-width: 768px) {\n    justify-content: flex-end;\n  }\n\n  .engagement-stat {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.15rem;\n    font-size: 0.875rem;\n    color: #64748b;\n    min-width: 2.5rem;\n  }\n}\n\n// ── Description & lower content ───────────────────────────────────────────────\n.listing-content-section {\n  background: #fff;\n  border: 1px solid #e8ecf0;\n  border-radius: 14px;\n  padding: 1.5rem 1.75rem;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\n.description-body {\n  font-size: 1rem;\n  line-height: 1.75;\n  color: #334155;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin: 0;\n}\n\n// ── Legacy vehicle-card (kept for safety/comfort tabs area) ───────────────────\n.vehicle-card {\n  display: none;\n}\n\n.flex-container {\n  display: block;\n}\n\n// ── Image gallery ─────────────────────────────────────────────────────────────\n.image-gallery {\n  margin-top: 0;\n\n  .main-image {\n    cursor: pointer;\n    margin-bottom: 0;\n    position: relative;\n    border-radius: 14px;\n    overflow: hidden;\n    border: 1px solid #e8ecf0;\n    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n\n    .main-img {\n      width: 100%;\n      height: 380px;\n      object-fit: cover;\n      border-radius: 0;\n      transition: transform 0.25s ease;\n\n      &:hover {\n        transform: scale(1.015);\n      }\n    }\n  }\n}\n\n.image-360 {\n  cursor: grab;\n  user-select: none;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.image-360-indicator,\n.image-360-controls {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 5px 10px;\n  border-radius: 15px;\n  font-size: 0.8rem;\n  z-index: 10;\n}\n\n// ── Lightbox ──────────────────────────────────────────────────────────────────\n.lightbox-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lightbox-content {\n  position: relative;\n  max-width: 90%;\n  max-height: 90%;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n\n  .close-btn,\n  .nav-btn {\n    position: absolute;\n    background: rgba(255, 255, 255, 0.8);\n    border: none;\n    font-size: 2rem;\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n\n    &:hover {\n      background: rgba(255, 255, 255, 1);\n    }\n  }\n\n  .close-btn {\n    top: -60px;\n    right: 0;\n  }\n\n  .prev {\n    left: -60px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .next {\n    right: -60px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .image-counter {\n    position: absolute;\n    bottom: -40px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: white;\n    background: rgba(0, 0, 0, 0.7);\n    padding: 5px 15px;\n    border-radius: 15px;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .listing-hero-top {\n    flex-direction: column;\n  }\n\n  .listing-price-block {\n    text-align: left;\n  }\n\n  .spec-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .lightbox-content {\n    .close-btn {\n      top: 10px;\n      right: 10px;\n      font-size: 1.5rem;\n      width: 40px;\n      height: 40px;\n    }\n\n    .prev,\n    .next {\n      font-size: 1.5rem;\n      width: 40px;\n      height: 40px;\n    }\n\n    .prev {\n      left: 10px;\n    }\n\n    .next {\n      right: 10px;\n    }\n\n    .image-counter {\n      bottom: 10px;\n    }\n  }\n}\n\n// ── Modals ────────────────────────────────────────────────────────────────────\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 500px;\n  padding: 0;\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.15);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.message-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  resize: vertical;\n}\n\n.report-error {\n  color: #842029;\n  margin-top: 8px;\n}\n\n.report-success {\n  color: #0f5132;\n  margin-top: 8px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
